import { Divider, VerticalStack, useBreakpoints } from "@shopify/polaris";

import {
  CTAText,
  DetailText,
  SpacedText,
  SubText,
} from './Components'
import LpForm from "./LpForm";

export default function SimpleTemplate({ fields, setLocalFields }) {

  console.log('fields', fields)
  const { mdDown } = useBreakpoints()

  return (
    <div style={{ boxSizing: 'border-box' }}>
      <div style={{ width: '100%', backgroundColor: '#f1f1f1', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom: '100px', paddingTop: '30px' }}>
        <div style={{ width: mdDown ? '100%' : '40%', minWidth: mdDown ? '' : '700px', maxWidth: '700px', height: '90%', backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ padding: '40px 0' }}>
            <VerticalStack gap="6" inlineAlign="center">
              <VerticalStack gap="2">
                <div style={{ textAlign: 'center' }}>
                  <SpacedText>{fields?.hero?.preheader}</SpacedText>
                </div>
                <img src={fields?.storeData?.logo} style={{ width: '200px', height: 'auto' }} />
              </VerticalStack>
              <DetailText>{fields?.hero?.header}</DetailText>
            </VerticalStack>
          </div>
          <div style={{
            width: '100%',
            height: '300px',
            backgroundColor: 'lightgray',
            background: `url("${fields?.hero?.image ? fields?.hero?.image : 'https://assets.codepen.io/6060109/default-lp-hero-1.jpg'}")`,
            backgroundSize: fields?.hero?.size === 'Full Width' ? '100%' : fields?.hero?.size === 'Full Height' ? 'auto 100%' : fields?.hero?.size === 'Contain' ? 'contain' : 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: fields?.hero?.position === 'top' ? 'top' : fields?.hero?.position === 'center' ? 'center' : 'bottom',
          }}>
          </div>
          <div style={{ padding: mdDown ? '50px 0' : '50px 20%', width: '100%' }}>
            <VerticalStack gap="10" inlineAlign="stretch">
              <VerticalStack gap="5">
                <div style={{ textAlign: 'center' }}>
                  <CTAText>{fields?.about?.header}</CTAText>
                </div>
                <div style={{ textAlign: 'center', lineHeight: 1.3 }}>
                  <SubText>{fields?.about?.text}</SubText>
                </div>
              </VerticalStack>
              <Divider />
              <div style={{ padding: mdDown ? '0 10px' : '' }}>
                <LpForm formID={fields?.id} customFields={fields?.customFields} setCustomFields={(value) => {
                  setLocalFields({
                    ...fields,
                    customFields: value
                  })
                }} />
              </div>
              <Divider />
              <VerticalStack gap="3" inlineAlign="center">
                <SpacedText>{fields?.contact?.header}</SpacedText>
                <SubText>{fields?.contact?.email}</SubText>
              </VerticalStack>
            </VerticalStack>
          </div>
        </div>
      </div>
    </div>
  )
}
